<template>
  <AuditTable
    :auditId="this.$route.params.categoryId"
    :auditType="'categories'"/>
</template>

<script>
import AuditTable from '@/components/Audit/AuditTable.vue';

export default {
  name: 'CategoryDetailsLogs',
  components: {
    AuditTable,
  },

  computed: {},

  data () {
    return {};
  },
};
</script>
